const adsSupportedCountries = ['US',
// United States
'CA',
// Canada
'MX',
// Mexico
'AT',
// Austria
'GB',
// United Kingdom
'FR',
// France
'DE',
// Germany
'IT',
// Italy
'ES',
// Spain
'NL',
// Netherlands
'SE',
// Sweden
'PL',
// Poland
'CZ',
// Czech Republic
'TR',
// Turkey
'BE',
// Belgium
'EG',
// Egypt
'AE',
// United Arab Emirates
'SA',
// Saudi Arabia
'IL',
// Israel
'SG',
// Singapore
'AU',
// Australia
'JP',
// Japan
'IN',
// India
'CN',
// China
'KR',
// South Korea
'TH',
// Thailand
'VN',
// Vietnam
'TW',
// Taiwan
'BR',
// Brazil
'CO' // Colombia
];

/* eslint-disable id-length */
const allCountries = [...adsSupportedCountries, 'LU',
// Luxembourg
'CH',
// Switzerland
'NO',
// Norway
'NZ',
// New Zealand
'DK',
// Denmark
'IE',
// Ireland
'FI',
// Finland
'MA',
// Morocco
'BH',
// Bahrain
'QA',
// Qatar
'KW',
// Kuwait
'ID',
// Indonesia
'PT',
// Portugal
'RO',
// Romania
'GR',
// Greece
'HU',
// Hungary
'ZA',
// South Africa
'SK',
// Slovakia
'HR',
// Croatia
'BG',
// Bulgaria
'PK',
// Pakistan
'LT',
// lithuania
'EE',
// Estonia
'LV',
// Latvia
'DZ',
// Algeria
'TN',
// Tunisia
'CY',
// Cyprus
'PH',
// Philippines
'MY',
// Malaysia
'HK',
// Hong Kong
'CL',
// Chile
'AR',
// Argentina
'PE',
// Peru
'EC',
// Ecuador
'CR',
// Costa Rica
'GT',
// Guatemala
'PA',
// Panama
'UY',
// Uruguay
'DO',
// Dominican Republic
'PR',
// Puerto Rico
'SV',
// El Salvador
'PY',
// Paraguay
'HN',
// Honduras
'JM' // Jamaica
];

export { allCountries as a, adsSupportedCountries as b };
//# sourceMappingURL=countryLists-D9DY8nsA.js.map
